import { toast } from "sonner";

// Ask once for browser notification permission (best-effort).
export function ensureNotifyPermission() {
  try {
    if ("Notification" in window && Notification.permission === "default") {
      Notification.requestPermission().catch(() => {});
    }
  } catch { /* unsupported */ }
}

// Fire a browser notification; always fall back to an in-app toast.
export function notify(title, body, { kind = "message" } = {}) {
  let shown = false;
  try {
    if ("Notification" in window && Notification.permission === "granted") {
      new Notification(title, { body });
      shown = true;
    }
  } catch { /* ignore */ }
  if (!shown) {
    if (kind === "warning") toast.warning(title, { description: body });
    else toast.success(title, { description: body });
  }
}
